const textProps = {
  icon: "fas fa-place-of-worship",
  title: "Connect with founders",
  description:
    "As we live, our hearts turn colder. Cause pain is what we go through as we become older and we get insulted",
};

export default textProps;
